// src/components/InstitutionalSchedulePage.jsx
import React, { useMemo, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ScheduleDisplay from './ScheduleDisplay'; // Correct path
import { setLastInstitutionUrlEndpoint } from '../utils/lastInstitutionUrlEndpoint';
// You might import useAuth here if this page needs to behave differently for logged-in users
// import { useAuth } from '../contexts/AuthContext';

const InstitutionalSchedulePage = ({ user, teachers, groups, subjects, rooms, isAssetsLoading = false, onAddGroup }) => {
    const { institutionUrlEndpoint, sharedDraftSlug } = useParams();
    // const { user } = useAuth(); // Optional: if behavior changes for logged-in users viewing a public page

    console.log('[InstitutionalSchedulePage] Rendering for endpoint:', institutionUrlEndpoint);

    // This component will now rely on apiService being correctly initialized
    // by ApiServiceInitializer in App.jsx, which will use this institutionUrlEndpoint
    // from the path for public API calls if no token is present.

    // If ScheduleDisplay needs specific filters for an institutional view, define them here.
    // For example, you might want to pre-filter by a specific date range or event type
    // based on the institution or other query parameters.
    const filters = useMemo(() => {
        // Example: If you had query params like ?startDate=YYYY-MM-DD
        // const query = new URLSearchParams(window.location.search);
        // const startDate = query.get('startDate');
        const baseFilters = {};
        // if (startDate) baseFilters.startDate = startDate;

        // IMPORTANT: The 'institutionUrlEndpoint' itself is NOT a filter for getScheduleEntries.
        // The apiService uses it to construct the correct base URL (public or private)
        // and the backend handles scoping for authenticated users.
        // For public calls, the institution is part of the path.

        return baseFilters;
    }, [/* dependencies for filters if any, e.g., location.search */]);

    const include = useMemo(() => (
        'subject,teacher,group,room' // Example: include common associations
    ), []);

    useEffect(() => {
        if (institutionUrlEndpoint && !sharedDraftSlug) {
            setLastInstitutionUrlEndpoint(institutionUrlEndpoint);
        }
    }, [institutionUrlEndpoint, sharedDraftSlug]);

    // The `user` prop passed to ScheduleDisplay is for UI elements (like Admin controls)
    // or user-specific actions *within* ScheduleDisplay.
    // ScheduleDisplay's call to getScheduleEntries() will use the apiService,
    // which knows if a user is logged in (via AuthContext via initializer)
    // and knows the institutionUrlEndpoint (via initializer) for public calls.
    return (
        <div>
            {/*
              You might fetch and display institution details here too using:
              useEffect(() => {
                  const fetchSettings = async () => {
                      try {
                          // apiService.getInstitutionSettings will use the initialized getter for url endpoint
                          const settings = await getInstitutionSettings();
                          // setInstitutionName(settings.name);
                      } catch (e) { console.error(e); }
                  };
                  fetchSettings();
              }, [institutionUrlEndpoint]); // Re-fetch if endpoint changes
            */}
            {/* <h1>Schedule for Institution: {institutionUrlEndpoint || 'Loading...'}</h1> */}
            <ScheduleDisplay
                user={user}
                teachers={teachers}
                groups={groups}
                subjects={subjects}
                rooms={rooms}
                isAssetsLoading={isAssetsLoading}
                filters={filters}
                include={include}
                isPublicView={true}
                isSharedDraft={!!sharedDraftSlug}
                onAddGroup={onAddGroup}
            />
        </div>
    );
};

// Default export was missing, adding it.
export { InstitutionalSchedulePage }; // Assuming it's a named export if App.jsx imports it as such.
// If it's default: export default InstitutionalSchedulePage;
// Checking App.jsx: import { InstitutionalSchedulePage } ... so named export is correct.